import { gql } from '@apollo/client'

export const GET_SIGNUP_PHONE_STEP_PROFILE = gql`
  query GetSignupPhoneStepProfile {
    root {
      viewer: me {
        user {
          profile {
            mainPhone {
              phone
            }
          }
        }
      }
    }
  }
`
